import React from "react";
import { Link } from "react-router-dom";

const SupportAccessDenied = () => {
  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white border rounded-md shadow-sm p-6 text-center">
        <h2 className="text-xl font-semibold text-red-600">Access Denied</h2>
        <p className="text-gray-600 mt-2">You do not have permission for this support module.</p>
        <Link to="/support/dashboard" className="inline-block mt-4 text-blue-600 underline">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
};

export default SupportAccessDenied;

